/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateHardwarePreferencesRequest
 */
export interface UpdateHardwarePreferencesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHardwarePreferencesRequest
     */
    preferredCashMachine?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHardwarePreferencesRequest
     */
    preferredDataphone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHardwarePreferencesRequest
     */
    preferredTill?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHardwarePreferencesRequest
     */
    useSelfPrinter?: boolean;
}

/**
 * Check if a given object implements the UpdateHardwarePreferencesRequest interface.
 */
export function instanceOfUpdateHardwarePreferencesRequest(value: object): value is UpdateHardwarePreferencesRequest {
    return true;
}

export function UpdateHardwarePreferencesRequestFromJSON(json: any): UpdateHardwarePreferencesRequest {
    return UpdateHardwarePreferencesRequestFromJSONTyped(json, false);
}

export function UpdateHardwarePreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHardwarePreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredCashMachine': json['preferredCashMachine'] == null ? undefined : json['preferredCashMachine'],
        'preferredDataphone': json['preferredDataphone'] == null ? undefined : json['preferredDataphone'],
        'preferredTill': json['preferredTill'] == null ? undefined : json['preferredTill'],
        'useSelfPrinter': json['useSelfPrinter'] == null ? undefined : json['useSelfPrinter'],
    };
}

export function UpdateHardwarePreferencesRequestToJSON(json: any): UpdateHardwarePreferencesRequest {
    return UpdateHardwarePreferencesRequestToJSONTyped(json, false);
}

export function UpdateHardwarePreferencesRequestToJSONTyped(value?: UpdateHardwarePreferencesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferredCashMachine': value['preferredCashMachine'],
        'preferredDataphone': value['preferredDataphone'],
        'preferredTill': value['preferredTill'],
        'useSelfPrinter': value['useSelfPrinter'],
    };
}

